import React from "react";
import Typography from "@material-ui/core/Typography";
import { inventarioResources } from "../endpoints";
import SnackbarAlert from "../components/SnackbarAlert";
import Button from "@material-ui/core/Button";
import { Link, withRouter } from "react-router-dom";
import useToken from "../useToken";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    CircularProgress,
    TextField,
    SvgIcon,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import {
    CheckBoxSharp,
    Person,
    SkipNext,
    SkipPrevious,
} from "@material-ui/icons";
import CreateIcon from "@material-ui/icons/Create";
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import InsightsIcon from "@mui/icons-material/Insights";
import DialogInvRef from "../components/DialogInvRef";
import DialogExportar from "../components/DialogExportar";
import DialogEnviarProductividad from "../components/DialogEnviarProductividad";
import DialogInternet from "../components/DialogInternet";
import DialogAnalistaResponsable from "../components/DialogAnalistaResponsable";
import DialogCircularProgress from "../components/DialogCircularProgress";
import { DataGrid } from "@mui/x-data-grid";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogCorreoTienda from "../components/DialogCorreoTienda";

class Inventarios extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            file: "",
            disponibles: [],
            total: 0,
            paginationModel: {
                page: 0,
                pageSize: 25
            },
            inventario: "",
            openSnack: false,
            severity: "",
            message: "",
            importar_respaldo: false,
            datos: useToken.getDatos(),
            user: useToken.getUser(),
            progress: false,
            cerrar_inv: false,
            folio: "",
            selectedRow: null,
            ingresar_inv_ref: false,
            modificar_inv_ref: false,
            rowData: null,
            open: false,
            walmart: false,
            enviar_prod: false,
            conectar_internet: false,
            internet: false,
            servidor: window.location.hostname,
            boton_prod_activo: true,
            ingresar_analista_responsable: false,
            modificar_analista_responsable: false,
            enviando: false,
            searchText: "",
            archivar_inventario:false,
            modificar_correo_tienda: false
        };
    }

    handleOnFileChange = (e) => {
        let file = e.target.files[0];
        this.setState({
            [e.target.id]: file,
        });
    };

    submitRespaldo = () => {
        this.setState({ progress: true, openSnack: false });
        const formData = new FormData();
        formData.append("file", this.state.file);
        inventarioResources
            .importarRespaldo(formData)
            .then(async (response) => {
                if (response) return await response.json();
            })
            .then((result) => {
                if (result.message) {
                    this.obtenerInvDisponibles();
                    this.setState({
                        openSnack: true,
                        severity: result.severity,
                        progress: false,
                        message: result.message,
                        importar_respaldo: false,
                    });
                } else throw new Error("Something went wrong ...");
            })
            .catch((error) => {
                console.error(error);
                this.setState({
                    progress: false,
                    openSnack: true,
                    severity: "error",
                    message: "Ha ocurrido un error inesperado",
                    importar_respaldo: false,
                });
            });
    };

    obtenerInvDisponibles = () => {
        const { page, pageSize } = this.state.paginationModel;
        inventarioResources
            .getInvDisponibles(page, pageSize, this.state.searchText)
            .then(async (response) => {
                if (response) return await response.json();
            })
            .then((data) => {
                if (data.status_code === 200) {
                    this.setState({
                        disponibles: data.inv_disponibles,
                        total: data.total
                    });
                } 
                else if (data.status_code === 401) {
                    this.setState({
                        openSnack: true,
                        severity: data.severity,
                        message: data.message,
                    });
                }
            })
            .catch((error) => console.error(error));
    };

    cambiarInv = (rowData) => {
        this.setState({
            openSnack: false,
            severity: null,
            message: null,
            ingresar_inv_ref: false,
            ingresar_analista_responsable: false,
        });

        const { folio, id_cliente } = rowData;

        inventarioResources
            .cambiarInv(folio, id_cliente)
            .then(async (response) => response && await response.json())
            .then((result) => {
                if (!result?.message) {
                    throw new Error("Respuesta inválida");
                }

                const token = result.access_token;

                if (token) {
                    useToken.setToken(token, rowData);

                    // 🔥 MOSTRAR SNACKBAR Y NO NAVEGAR
                    this.setState({
                        openSnack: true,
                        severity: result.severity,
                        message: result.message,
                        datos: useToken.getDatos(),
                    });
                } else {
                    this.setState({
                        openSnack: true,
                        severity: result.severity,
                        message: result.message,
                    });
                }
            })
            .catch((error) => {
                console.error(error);
                this.setState({
                    openSnack: true,
                    severity: "error",
                    message: "Ha ocurrido un error inesperado",
                });
            });
    };

    verificaCambiaInv = (rowData) => {
        if(this.state.user.perfil === 'analista' && rowData.estado === 'abierto' && rowData.cliente === "SODIMAC"){
            this.setState({ingresar_inv_ref:true,rowData:rowData});
        }
        else if (!(this.state.user.perfil === 'analista') && rowData.estado === 'abierto' && rowData.cliente === "SODIMAC"){
            this.verificarAnalistaCoordinadorResponsable(rowData)
        }
        else if (rowData.estado === 'abierto' && (rowData.cliente === "WALMART" || rowData.cliente === "WALMART PARCIALES")){
            this.verificarAnalistaCoordinadorResponsable(rowData)
        }
        else{
            this.cambiarInv(rowData)
        }
    };

    modificarInvRef = (rowData) => {
        if(this.state.user.perfil === 'analista' && rowData.estado === 'abierto'){
            this.setState({modificar_inv_ref:true,rowData:rowData});
        }
    };

    modificarCorreoTienda = (rowData) => {
        if((this.state.user.perfil === 'oficina SCA' || this.state.user.perfil === 'admin') && (rowData.estado === 'abierto' || rowData.estado === 'precerrado')){
            this.setState({modificar_correo_tienda:true,rowData:rowData});
        }
    };

    enviarProductividad = (rowData) => {
        this.setState({openSnack:false, severity: null, message:null})
        if(rowData.estado !== 'abierto' && rowData.app !== 'sodimac'){
            this.setState({enviar_prod:true,rowData:rowData});
        }
    };

    refrescarinvRef = (result) => {
        this.setState({openSnack:false, severity: null, message:null})
        if(result.status_code === 200){
            if(this.state.ingresar_inv_ref){
                this.cambiarInv(this.state.rowData);
            }
            else{
                this.setState({
                    openSnack: true,
                    severity: result.severity,
                    message: result.message,
                    modificar_inv_ref:false
                })
            }

        }
        else{
            this.setState({
                openSnack: true,
                severity: result.severity,
                message: result.message,
            })
        }
    };

    refrescarAnalistaResp = (result) => {
        this.setState({openSnack:false, severity: null, message:null})
        if(result.status_code === 200){
            if(this.state.ingresar_analista_responsable){
                this.cambiarInv(this.state.rowData);
            }
            else{
                this.setState({
                    openSnack: true,
                    severity: result.severity,
                    message: result.message,
                    modificar_analista_responsable:false
                })
            }

        }
        else{
            this.setState({
                openSnack: true,
                severity: result.severity,
                message: result.message,
            })
        }
    };

    verificarAnalistaCoordinadorResponsable = (rowData) => {
        inventarioResources.verificaAnalistaCoordinadorResponsable(rowData.folio).then(async response =>{
        if (response){
            return await response.json();
        }
        }).then(data => {
            if (data){
                this.cambiarInv(rowData)
            }
            else{
                this.setState({ingresar_analista_responsable: true, rowData: rowData})
            }

        }).catch(error=> {
            this.cambiarInv(rowData)
        });
    };

    respaldar_invetario = (rowData) => {
        this.setState({openSnack:false, severity: null, message:null})
        inventarioResources.respaldarInv(rowData.folio).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(data => {
            if(data.message){
                this.setState({
                    openSnack: true,
                    severity: data.severity,
                    message: data.message,
                })
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error);
            this.setState({
                openSnack: true,
                severity: 'error',
                message: "Ha ocurrido un error inesperado",
            })
        });
    };

    refrescar = (estado, severity) => {
        this.setState({
            openSnack: false
        }, () => {

            if (severity === "success") {
                this.obtenerInvDisponibles();
            }

            this.setState({
                openSnack: true,
                severity: severity,
                message: estado,
                cerrar_inv: false,
                modificar_correo_tienda: false
            });

        });
    };
    
    handleClose = () => {
        this.setState({modificar_correo_tienda:false, ingresar_analista_responsable:false,modificar_analista_responsable:false,
            conectar_internet:false ,open:false,cerrar_inv:false, ingresar_inv_ref:false, modificar_inv_ref:false, enviar_prod:false})
    };

    archivarInventario = (rowData)=>{
        this.setState({archivar_inventario:true,rowData:rowData});
    }

    confirmaArchivarInventario = () => {
        this.setState({archivar_inventario:false,openSnack:false, severity: null, message:null}, () => {
            inventarioResources.archivarInventario(this.state.rowData.folio).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if(data.message){
                    this.obtenerInvDisponibles()
                    if(data.status_code === 200){
                        if (this.state.datos !== null){
                            if(this.state.rowData.folio === this.state.datos.folio){
                                useToken.clearDatos();
                            }
                        }
                    }
                    this.setState({
                        openSnack: true,
                        severity: data.severity,
                        message: data.message,
                    })
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.error(error);
                this.setState({
                    openSnack: true,
                    severity: 'error',
                    message: "Ha ocurrido un error inesperado",
                })
            });
        })
    };

    modificarEstado = (folio, estado) => {
        if (estado !== "enviado") {
            inventarioResources.modificarEstadoInv(folio, estado).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if (data.message) {
                    this.obtenerInvDisponibles()
                    this.setState({
                        conectar_internet:false,
                        openSnack: true,
                        severity: data.severity,
                        message: data.message,
                    })
                } else {
                    throw new Error('Something went wrong ...');
                }
            }).catch(error => {
                console.error(error);
                this.setState({
                    conectar_internet:false,
                    openSnack: true,
                    severity: 'error',
                    message: "Ha ocurrido un error inesperado",
                })

            });

        } else {
            this.setState({ enviando: true });

            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 300000);

            inventarioResources.enviarInventario(folio, { signal: controller.signal })
                .then(async response => {
                    clearTimeout(timeoutId); // Limpiamos el reloj si el backend respondió con éxito
                    
                    if (response) {
                        return await response.json();
                    }
                })
                .then(data => {
                    if (data.message) {
                        this.obtenerInvDisponibles();
                        this.setState({
                            openSnack: true,
                            severity: data.severity,
                            message: data.message,
                            enviando: false, // 🟢 Desbloqueamos la pantalla con éxito
                        });
                    } else {
                        throw new Error('Something went wrong ...');
                    }
                })
                .catch(error => {
                    clearTimeout(timeoutId); // Limpiamos el reloj también en caso de error
                    console.error(error);

                    // Detectamos si el error fue porque REALMENTE se cumplieron los 5 minutos de espera
                    const fuePorTimeout = error.name === 'AbortError';

                    this.setState({
                        openSnack: true,
                        severity: 'error',
                        message: fuePorTimeout 
                            ? "El servidor tardó más de 5 minutos en responder. Verifica el estado en Procesos."
                            : "Ha ocurrido un error inesperado durante el envío.",
                        enviando: false, // 🟢 Desbloqueamos la pantalla para permitir reintentar si falló
                    });
                });
        }
        const datos =  JSON.parse(localStorage.getItem('datos'))
        if (datos !== null){
            if(folio === datos.folio){
                datos.estado = estado
                localStorage.setItem('datos', JSON.stringify(datos));
            }
        }
    };

    refrescarExportar = (estado, severity) => {
        this.setState({
            open: false,
            enviar_prod:false,
            openSnack: true,
            message: estado,
            severity: severity})
    };

    modificarEstadoInvAdelante = (rowData) => {
        let estado = null
        this.setState({openSnack: false, severity: null, message: null})
        if (rowData.estado === "abierto") {
            estado = "precerrado"
        } else if (rowData.estado === "precerrado") {
            /*if (rowData.app !== 'sodimac' || rowData.app !== 'smu_auditoria') {
                if (!internet) {
                    this.setState({conectar_internet: true, rowData: rowData})
                } else {
                    estado = "cerrado"
                }
            } else {
                estado = "cerrado"
            }
             */
            estado = "cerrado"
        } else if (rowData.estado === "cerrado") {
            estado = "bloqueado"
        } else if (rowData.estado === "bloqueado") {
            estado = "enviado"
        }
        this.modificarEstado(rowData.folio, estado)
    };

    modificarEstadoInvAtras = (rowData) => {
        let estado = null
        this.setState({openSnack:false, severity: null, message:null})
        if(rowData.estado === "bloqueado"){
            estado = "cerrado"
        }
        else if(rowData.estado === "cerrado"){
            estado = "precerrado"
        }
        else if(rowData.estado === "precerrado"){
            estado = "abierto"
        }
        this.modificarEstado(rowData.folio, estado)
    };

    listadoAsistencia = (rowData) => {
        let params = rowData.folio
        let reporte = "asistencia_operadores"
        this.setState({open: true, reporte: reporte, params: params,openSnack:false})
    };

    detieneReportes = () => {
        this.setState({openSnack:false, severity: null, message:null})
        inventarioResources.detenerReportesAuto().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(data => {
            if(data.message){
                this.setState({
                    openSnack: true,
                    severity: data.severity,
                    message: data.message,
                })
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error);
            this.setState({
                openSnack: true,
                severity: 'error',
                message: "Ha ocurrido un error inesperado",
            })
        });
    };

    componentDidMount() {
        this.obtenerInvDisponibles()
        this.verificaWalmart()

        if (this.state.servidor === "170.187.153.231" && this.state.servidor === "50.116.47.193") {
            this.setState({boton_prod_activo:false})
        } else {
            this.setState({boton_prod_activo:true})
        }
        // 🔥 Escucha cuando cambie el token
        window.addEventListener("token-updated", this.handleTokenUpdated);
    }

    componentWillUnmount() {
        window.removeEventListener("token-updated", this.handleTokenUpdated);
    }

    handleTokenUpdated = () => {
        this.setState({
            user: useToken.getUser(),
            datos: useToken.getDatos()
        }, () => {
            this.verificaWalmart();
            this.obtenerInvDisponibles();
        });
    };

    verificaWalmart() {
        let datos_inv = useToken.getDatos()
        if (datos_inv.app ==='walmart' || datos_inv.app ==='walmart_parciales'){
            this.setState({walmart: true})
        }
        else{
            this.setState({walmart: false})
        }
    }

    render() {
        const rows = this.state.disponibles;

        return (
            <div>
                <Typography variant="h4" gutterBottom>
                    Inventarios disponibles
                </Typography>

                {/* Botones superiores */}
                <div style={{ display: "flex", justifyContent: "end" }}>
                    <Link to={"/agregar_inv"} style={{ color: "#000", textDecoration: "none" }}>
                        <Button size="large" variant="contained" color="primary">
                            Agregar inventario
                        </Button>
                    </Link>
                    <Button
                        style={{ marginLeft: "5px" }}
                        size="large"
                        variant="contained"
                        color="primary"
                        onClick={() => this.setState({ importar_respaldo: true })}
                    >
                        Importar respaldo de inventario
                    </Button>
                    {this.state.walmart && (
                        <Button
                            style={{ marginLeft: "5px" }}
                            size="large"
                            variant="contained"
                            color="primary"
                            onClick={() => this.detieneReportes()}
                        >
                            Detiene reportes automáticos
                        </Button>
                    )}
                </div>

                {/* Cuadro de búsqueda */}
                <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px 0" }}>
                    <TextField
                        label="Buscar"
                        variant="outlined"
                        size="small"
                        value={this.state.searchText}
                        onChange={(e) => {
                            this.setState(
                                { 
                                    searchText: e.target.value,
                                    paginationModel: { ...this.state.paginationModel, page: 0 }
                                },
                                () => this.obtenerInvDisponibles()
                            );
                        }}
                    />
                </div>

                {/* DataGrid reemplazando MaterialTable */}

                <div style={{ width: '100%', overflowX: 'auto' }}>
                    <div style={{ minWidth: 1200 }}> {/* ancho mínimo según tus columnas */}
                    <DataGrid
                        density="compact"
                        style={{
                            minWidth: '900px',           // 🔹 asegura tamaño legible
                            width: '100%',
                            height: '100%',                 // 🔹 altura fija o ajustable
                        }}
                        sx={{
                            fontSize: '2rem',
                            '& .MuiDataGrid-columnHeaders': {
                                fontSize: '1rem',
                                fontWeight: 'bold',
                            },
                            '& .MuiDataGrid-cell': {
                                fontSize: '1rem',
                            },
                            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus': {
                                outline: 'none',
                            },
                            '& .MuiDataGrid-virtualScroller': {
                                overflowX: 'auto',         // 🔹 activa el scroll horizontal solo dentro del grid
                            },
                        }}
                        rows={rows}
                        getRowId={(row) => row.folio}
                        paginationMode="server"
                        rowCount={this.state.total}
                        paginationModel={this.state.paginationModel}
                        onPaginationModelChange={(model) => {
                            this.setState(
                                { paginationModel: model },
                                () => this.obtenerInvDisponibles()
                            );
                        }}
                        pageSizeOptions={[25,50,100]}
                        columns={[
                            { field: "folio", headerName: "Folio", flex: 0.5 },
                            {
                                field: "fecha",
                                headerName: "Fecha",
                                flex: 0.5,
                                valueGetter: (params) =>
                                    params.row.fecha?.split("-").reverse().join("/") || "",
                            },
                            { field: "cliente", headerName: "Cliente", flex: 1 },
                            { field: "centro_descripcion", headerName: "Tienda", flex: 1.2 },
                            { field: "comentario", headerName: "Comentarios", flex: 1.2 },
                            {
                                field: "estado",
                                headerName: "Estado",
                                flex: 0.5,
                                valueGetter: (params) =>
                                    params.row.estado
                                        ? params.row.estado.charAt(0).toUpperCase() +
                                        params.row.estado.slice(1)
                                        : "",
                            },
                            {
                                field: "acciones",
                                headerName: "Acciones",
                                flex: 1,
                                sortable: false,
                                renderCell: (params) => {
                                    const row = params.row;
                                    return (
                                        <div style={{ display: "flex", gap: 4 }}>
                                            <Tooltip title="Cambiar a este inventario">
                                                <IconButton onClick={() => this.verificaCambiaInv(row)}>
                                                    <CheckBoxSharp htmlColor="black"/>
                                                </IconButton>
                                            </Tooltip>

                                            {!(row.estado === "enviado" || row.estado === "abierto") && (
                                                <Tooltip title="Volver a estado anterior">
                                                    <IconButton onClick={() => this.modificarEstadoInvAtras(row)}>
                                                        <SkipPrevious htmlColor="black"/>
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {row.estado !== "enviado" && (
                                                <Tooltip title="Avanzar a estado siguiente">
                                                    <IconButton onClick={() => this.modificarEstadoInvAdelante(row)}>
                                                        <SkipNext htmlColor="black"/>
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {row.estado === "enviado" && this.state.user.perfil.includes("operador") && (
                                                <Tooltip title="Archivar inventario">
                                                    <IconButton onClick={() => this.archivarInventario(row)}>
                                                        <DeleteIcon htmlColor="red"/>
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            <Tooltip title="Respaldar inventario">
                                                <IconButton onClick={() => this.respaldar_invetario(row)}>
                                                    <SvgIcon htmlColor="black">
                                                        <path
                                                            fill="currentColor"
                                                            d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35"
                                                        />
                                                    </SvgIcon>
                                                </IconButton>
                                            </Tooltip>

                                            {row.estado === "abierto" && row.app === "sodimac" && this.state.user.perfil === 'analista' && (
                                                <Tooltip title="Modificar inv. referencia">
                                                    <IconButton onClick={() => this.modificarInvRef(row)}>
                                                        <CreateIcon htmlColor="black"/>
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {(row.estado === "abierto" || row.estado === 'precerrado') && row.app === "smu_perecible" && (
                                                <Tooltip title="Modificar correo tienda">
                                                    <IconButton onClick={() => this.modificarCorreoTienda(row)}>
                                                        <AlternateEmailIcon htmlColor="black"/>
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {row.estado !== "abierto" &&
                                                row.app !== "sodimac" &&
                                                this.state.boton_prod_activo && (
                                                    <Tooltip title="Enviar datos de productividad a Gestión">
                                                        <IconButton onClick={() => this.enviarProductividad(row)}>
                                                            <InsightsIcon htmlColor="black" />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                            <Tooltip title="Lista de asistencia">
                                                <IconButton onClick={() => this.listadoAsistencia(row)}>
                                                    <Person htmlColor="black"/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    );
                                },
                            },
                        ]}
                        hideFooterSelectedRowCount
                        //onRowClick={(params) => this.verificaCambiaInv(params.row)}
                        onCellClick={(params, event) => {
                            if (params.field !== 'acciones') {
                                this.verificaCambiaInv(params.row);
                            }
                        }}
                        disableColumnMenu
                    />
                    </div>
                </div>

                {/* Mantiene todos tus diálogos y alerts */}
                {this.state.openSnack && (
                    <SnackbarAlert severity={this.state.severity} message={this.state.message} />
                )}
                {this.state.ingresar_inv_ref && (
                    <DialogInvRef
                        rowData={this.state.rowData}
                        title={"Ingresar inv. referencia"}
                        refrescar={this.refrescarinvRef}
                        handleClose={this.handleClose}
                    />
                )}
                {this.state.modificar_inv_ref && (
                    <DialogInvRef
                        rowData={this.state.rowData}
                        title={"Modificar inv. referencia"}
                        refrescar={this.refrescarinvRef}
                        handleClose={this.handleClose}
                    />
                )}
                {this.state.ingresar_analista_responsable && (
                    <DialogAnalistaResponsable
                        rowData={this.state.rowData}
                        title={"Ingresar analista y coordinador responsable"}
                        refrescar={this.refrescarAnalistaResp}
                        handleClose={this.handleClose}
                    />
                )}
                {this.state.modificar_analista_responsable && (
                    <DialogAnalistaResponsable
                        rowData={this.state.rowData}
                        title={"Modificar analista y coordinador responsable"}
                        refrescar={this.refrescarAnalistaResp}
                        handleClose={this.handleClose}
                    />
                )}
                 {this.state.modificar_correo_tienda && (
                    <DialogCorreoTienda
                        rowData={this.state.rowData}
                        refrescar={this.refrescar}
                        handleClose={this.handleClose}
                    />
                )}
                {this.state.open && (
                    <DialogExportar
                        reporte={this.state.reporte}
                        origen={"otro"}
                        params={this.state.params}
                        refrescar={this.refrescarExportar}
                        handleClose={this.handleClose}
                    />
                )}
                {this.state.enviar_prod && (
                    <DialogEnviarProductividad
                        rowData={this.state.rowData}
                        refrescar={this.refrescarExportar}
                        handleClose={this.handleClose}
                    />
                )}
                {this.state.conectar_internet && (
                    <DialogInternet
                        rowData={this.state.rowData}
                        handleClose={this.handleClose}
                        confirmarCerrar={this.modificarEstado}
                    />
                )}
                {this.state.enviando && <DialogCircularProgress />}
                <Dialog
                    open={this.state.importar_respaldo}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Importar respaldo inventario</DialogTitle>
                    <DialogContent>
                        <TextField
                            disabled={this.state.disabled}
                            style={{width:'530px'}}
                            type={"file"}
                            id="file"
                            label="Seleccione archivo"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onChange={this.handleOnFileChange}
                        />
                    </DialogContent>
                    {this.state.progress ? <div style={{display: 'grid', justifyContent: 'center'}}>
                        <CircularProgress/>
                    </div> : null}
                    <DialogActions>
                        <Button variant="contained" color="secondary" onClick={()=>{this.setState({importar_respaldo:false})}}>
                            Cancelar
                        </Button>
                        <Button variant="contained" color="primary" onClick={this.submitRespaldo}>
                            Importar
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.archivar_inventario}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Archivar inventario</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Esta seguro que quiere archivar el inventario? Esta acción es irreversible, se borrarán todos los datos.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="secondary" onClick={()=>{this.setState({archivar_inventario:false})}}>
                            Cancelar
                        </Button>
                        <Button variant="contained" color="primary" onClick={this.confirmaArchivarInventario}>
                            Archivar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withRouter(Inventarios);
